import React, { useState } from "react";
import { Image, Modal, Button, Col } from "react-bootstrap";
import {
  PAYMENT_TYPE_FILTER,
  PAYMENT_METHOD_STATUS_FILTER,
  EXPERIENCE_STATUS_FILTER
} from "../../../../../enums/OrderEnums";
import { PopupInsideButton } from "../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";

const StatusFilter = (props) => {
  const statusType = [
    { id: 0, name: "All", value: "All" },
    { id: 1, name: "Active", value: true },
    { id: 2, name: "Inactive", value: false },
  ];

  const [open, setOpen] = useState(false);
  const [paymentType, setPaymentType] = useState(false);
  const [expstatus, setexpstatus] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(false);
  const [paymentTypeText, setPaymentTypeText] = useState(10);
  const [paymentStatusText, setPaymentStatusText] = useState(10);
  const [expStatusText, setexpStatusText] = useState('All');
  const [filtervalue, setfiltervalue] = useState("");

  const onChangeModal = () => {
    setOpen(!open);
  };

  const resetfilter = () => {
   // setfiltervalue("All");
    if (props?.statusfilter) {
      props.values("All");
    } else if (paymentType) {
      props.paymentMethodValues(10);
    } else if (paymentStatus) {
      props.paymentstatuvalues(10);
    }
    else if (props?.experiencestatus) {
      props.expstatusvalues("All");
    };
    onChangeModal();
  };

  const ApplyFilter = () => {
    if (props?.statusfilter) {
      props.values(filtervalue);
    } else if (paymentType) {
      props.paymentMethodValues(paymentTypeText);
    } else if (paymentStatus) {
      props.paymentstatuvalues(paymentStatusText);
    }
    else if (props?.experiencestatus) {
      props.expstatusvalues(expStatusText);
    }
    onChangeModal();
  };
  return (
    <>
      <div
        onClick={onChangeModal}
        className="d-flex align-items-center justify-content-between cursor"
      >
        <Image
          alt="filter"
          title="filter"
          width="48px"
          src={require("../../../../../assets/images/seatingImages/filter.svg")}
        />
      </div>
      <Modal show={open} onHide={onChangeModal} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title className="f18_700_HelveticaNeue">Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="f14-500 pb-4">
            Select one relevant option from below
          </div>
          <div className="d-flex align-items-center pb-4 justify-content-between">
            {/* {props?.statusfilter === true ? (
              <>
                <label className="f16-500">
                  Experience status
                </label>
              </>
            ) : null} */}
            {props?.paymentTypeFilter === true ? (
              <>
                <label className="enRadioWithText f12-500 mr-4">
                  Payment Type
                  <input
                    type="radio"
                    name="CouponDiscountType"
                    checked={paymentType}
                    onChange={() => {
                      //  setOrderType(false);
                      setPaymentType(true);
                      setPaymentStatus(false);
                    }}
                  />
                  <span className="checkmark"></span>
                </label>
              </>
            ) : null}
            {props?.paymentMethodfilter === true ? (
              <>
                <label className="enRadioWithText f12-500 mr-4">
                  Payment Status
                  <input
                    type="radio"
                    name="CouponDiscountType"
                    checked={paymentStatus}
                    onChange={() => {
                      setexpstatus(false);
                      setPaymentType(false);
                      setPaymentStatus(true);
                    }}
                  />
                  <span className="checkmark"></span>
                </label>
              </>
            ) : null}
            {props?.experiencestatus === true ? (
              <>
                <label className="enRadioWithText f12-500 mr-4">
                  Experience Status
                  <input
                    type="radio"
                    name="CouponDiscountType"
                    checked={expstatus}
                    onChange={() => {
                      setexpstatus(true);
                      setPaymentType(false);
                      setPaymentStatus(false);
                    }}
                  />
                  <span className="checkmark"></span>
                </label>
              </>
            ) : null}
          </div>
          <div className="d-flex  align-items-center justify-content-center">
            {props?.statusfilter &&
              statusType.map((data, index) => {
                return (
                  <React.Fragment key={index}>
                    <div
                      className="enCheckWithText mr-3"
                      onClick={() => setfiltervalue(data.value)}
                    >
                      <input type="radio" name="OfferType" />
                      <label
                        style={{
                          borderColor: `${
                            filtervalue === data.value ? "#ee3a23" : ""
                          }`,
                        }}
                      >
                        {data.name}
                      </label>
                    </div>
                  </React.Fragment>
                );
              })}
          </div>
          <div className="d-flex flex-wrap align-items-center">
            {paymentType
              ? PAYMENT_TYPE_FILTER.map((data, index) => {
                  return (
                    <>
                      <Col xs={4} key={index} className="mobile-p-0">
                        <PopupInsideButton
                          buttonClass={
                            paymentTypeText === data.value
                              ? "status-selected-button-box f11-700 mobile-f12-400 sts_sld_btn_box_a"
                              : "status-selected-button-box f11-700 mobile-f12-400"
                          }
                          buttonText={data.title}
                          buttonType="button"
                          onClick={() => setPaymentTypeText(data.value)}
                        />
                      </Col>
                    </>
                  );
                })
              : null}
          </div>
          <div className="d-flex flex-wrap align-items-center">
            {paymentStatus
              ? PAYMENT_METHOD_STATUS_FILTER.map((data, index) => {
                  return (
                    <>
                      <Col xs={4} key={index} className="mobile-p-0">
                        <PopupInsideButton
                          buttonClass={
                            paymentStatusText === data.value
                              ? "status-selected-button-box f11-700 mobile-f12-400 sts_sld_btn_box_a"
                              : "status-selected-button-box f11-700 mobile-f12-400"
                          }
                          buttonText={data.title}
                          buttonType="button"
                          onClick={() => setPaymentStatusText(data.value)}
                        />
                      </Col>
                    </>
                  );
                })
              : null}
          </div>
          <div className="d-flex flex-wrap align-items-center">
            {expstatus
              ? EXPERIENCE_STATUS_FILTER.map((data, index) => {
                  return (
                    <>
                      <Col xs={4} key={index} className="mobile-p-0">
                        <PopupInsideButton
                          buttonClass={
                            expStatusText === data.value
                              ? "status-selected-button-box f11-700 mobile-f12-400 sts_sld_btn_box_a"
                              : "status-selected-button-box f11-700 mobile-f12-400"
                          }
                          buttonText={data.title}
                          buttonType="button"
                          onClick={() => setexpStatusText(data.value)}
                        />
                      </Col>
                    </>
                  );
                })
              : null}
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={resetfilter}
            >
              Reset Filter
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              onClick={ApplyFilter}
            >
              Apply Filter
            </Button>
          </Modal.Footer>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default StatusFilter;
